/** Базовый стиль MUI Modal — используется во всех модальных окнах портала */
export const modalBaseStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'var(--bg-form)',
  border: '1px solid var(--border-input)',
  borderRadius: '5px',
  boxShadow: 24,
  p: 4,
};

/** Широкий вариант для форм */
export const modalWideStyle = { ...modalBaseStyle, width: 600 };
